export class Magliette {
  constructor(public nome: string, public qty: number, public img: string, public prezzo: number, public size: string) {}
}
